<!--
 * @Description:
 * @Author: 景 彡
 * @Date: 2024-10-30 12:00:07
 * @LastEditors: 景 彡
-->
<template>
  <div>6666</div>
</template>

<script setup lang="ts">
definePage({
  meta: {
    layout: 'admin',
    isLayout: true,
    local: true,
    title: '系统管理',
    icon: 'ApartmentOutlined',
    order: 2,
  },
})
</script>

<style scoped></style>
